import React, { FC } from "react";
import { Box, Tooltip, keyframes } from "@mui/material";

import { PinIcon } from "../../icons/PinIcon";
import { ThumbnailIcon } from "../../icons/ThumbnailIcon";

import { useAppStore } from "../../../hooks/useAppStore";
import OrgLogo from "./OrgLogo";

interface SidebarLogoContentProps {
  wasExpandedByHover: boolean;
  externalToggleSidebar?: () => void;
}

const SidebarLogoContent: FC<SidebarLogoContentProps> = ({
  wasExpandedByHover,
  externalToggleSidebar,
}) => {
  const { isCollapsed, isSidebarMobile, toggleSidebar } = useAppStore();

  const isVisible = !isCollapsed && !isSidebarMobile;

  return (
    <Box
      sx={{
        display: "flex",
        height: "var(--height-header, 64px)",
        alignItems: "center",
        px: 3,
        borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
        flexShrink: 0,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          width: "100%",
          justifyContent: isVisible ? "space-between" : "center",
        }}
      >
        {
          // Logo
          !isVisible ? null : <OrgLogo />
        }

        {/* Toggle button positioned to the right of logo */}
        <Tooltip
          title={wasExpandedByHover ? "Pin sidebar" : "Toggle sidebar"}
          placement="bottom"
          arrow
        >
          <Box
            component="button"
            onClick={wasExpandedByHover ? externalToggleSidebar : toggleSidebar}
            sx={{
              width: 24,
              height: 24,
              borderRadius: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "none",
              bgcolor: "transparent",
              cursor: "pointer",
              "&:hover": {
                bgcolor: "rgba(0, 0, 0, 0.04)",
              },
            }}
          >
            {wasExpandedByHover ? (
              <PinIcon />
            ) : (
              <ThumbnailIcon className="text-chat-text-primary" />
            )}
          </Box>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default SidebarLogoContent;
